import { render, staticRenderFns } from "./categorySubcategory.vue?vue&type=template&id=edb038cc&"
import script from "./categorySubcategory.vue?vue&type=script&lang=js&"
export * from "./categorySubcategory.vue?vue&type=script&lang=js&"
import style0 from "./categorySubcategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports